import { useEffect } from 'react'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import PageTitle from '../../components/PageTitle/PageTitle'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import ProductsItem from '../../components/ProductsItem/ProductsItem'

export default function Products() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <>
      <Header page={'products'} />
      <UnderHeader className={'products'} />
      <PageTitle mainTitle={'PRODUCTS'} page={'PRODUCTS'} />
      <ProductsItem />
      <LogoPartner />
      <Footer />
    </>
  )
}
